import { Controller } from '@hotwired/stimulus'

// Hero phone media (HeroTemplateV2Component mobile_media): a <video> picks its
// <source> once, at load, and never again when the viewport crosses the 743px
// line (phone rotated, window resized). A video whose only source is gated to
// the other range would stay an empty box — re-run the pick on every crossing.
export default class extends Controller {
  connect() {
    this.query = window.matchMedia('(max-width: 743px)')
    this.onChange = () => {
      this.element.querySelectorAll('video').forEach(video => {
        video.load()
        if (video.autoplay) video.play().catch(() => {})
      })
    }
    this.query.addEventListener('change', this.onChange)
  }

  disconnect() {
    this.query.removeEventListener('change', this.onChange)
  }
}
